import objectHasProperty from '../objectHasProperty';
import esTranslations from './es.json';

const message = (key: string) => {
  const translations: any = esTranslations;

  let result = key;
  if (objectHasProperty(translations, key)) {
    result = translations[key];
  }

  return result;
};

export default message;
